var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Header'),_c('div',{staticClass:"main",class:_vm.headerStyle,attrs:{"id":"main-right"}},[_c('router-view')],1),(_vm.$route.name != 'Download')?_c('Footer'):_vm._e(),_c('FloatButton')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }